export const notificationStatusMapping = {
    error: {
        iconProps: {
            name: 'falTimesCircle'
        },
        variant: 'subtleRed'
    },
    info: {
        iconProps: {
            name: 'falInfoCircle'
        },
        variant: 'subtleBlue'
    },
    loading: {
        iconProps: {
            animation: 'vui-spin 0.6s linear infinite',
            name: 'fadSpinnerThird',
            pathFill: ['blue.40', 'blue.60']
        },
        variant: 'subtleBlue'
    },
    success: {
        iconProps: {
            name: 'falCheckCircle'
        },
        variant: 'subtleGreen'
    },
    warning: {
        iconProps: {
            name: 'falExclamationCircle'
        },
        variant: 'subtleYellow'
    }
};
